import { mdiAlertCircle } from '@mdi/js';
import React, { useState } from 'react';
import { validateLatin1String } from '../../../utils';
import * as S from './compose-input.styles';

export interface IComposeInputProps {
    onChange: (subject: string) => void;
    onValidationChange?: (hasError: boolean) => void;
    disabled?: boolean;
    isNote?: boolean;
    maxLength?: number;
    subject?: string;
}

export const ComposeInput: React.FunctionComponent<IComposeInputProps> = (
    props: IComposeInputProps,
): React.ReactElement => {
    const { onChange, onValidationChange, disabled, isNote, maxLength, subject } = props;
    const [latin1ValidationError, setLatin1ValidationError] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newSubject = e.target.value;
        onChange(newSubject);
        // Clear validation error when user starts typing
        if (latin1ValidationError) {
            setLatin1ValidationError(null);
            onValidationChange?.(false);
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
        // Validate on blur
        const value = e.target.value;
        const validationResult = validateLatin1String(value);
        if (!validationResult.isValid) {
            setLatin1ValidationError(validationResult.errorMessage || null);
            onValidationChange?.(true);
        } else {
            setLatin1ValidationError(null);
            onValidationChange?.(false);
        }
    };
    return (
        <S.Container>
            <S.Label>Message Title</S.Label>
            <S.Wrapper disabled={disabled} isNote={isNote}>
                <S.Input
                    disabled={disabled}
                    placeholder="What's on your mind?"
                    value={subject || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength={maxLength || 80}
                />
            </S.Wrapper>
            {latin1ValidationError && (
                <S.Latin1Error>
                    <S.Latin1ErrorIcon path={mdiAlertCircle} size={0.7} />
                    {latin1ValidationError}
                </S.Latin1Error>
            )}
        </S.Container>
    );
};
